<div class="offcanvas-header" #header>
    <h5 class="offcanvas-title">{{ post.postType }}</h5>
    <button type="button" class="btn-close text-reset" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="offcanvas-body overflow-auto" style="max-height: 90vh">
    <div class="d-grid gap-1 mb-2">
        <button sfButton type="button" size="md" color="success">Process</button>
        <button sfButton type="button" size="md" color="primary">View</button>
    </div>
    @if (appointment; as appointment) {
        @if (appointment.customer; as customer) {
            <div class="small">
                <div class="row">
                    <div class="col">Customer</div>
                    <div class="col text-end fw-bold">
                        <a [routerLink]="['customers', customer.id]" target="_blank"
                            >{{ customer.fullName }} ({{ customer.id }})</a
                        >
                    </div>
                </div>
                <div class="row">
                    <div class="col">Address</div>
                    <div class="col text-end fw-bold">{{ customer.fullAddress }}</div>
                </div>
                <div class="row">
                    <div class="col">Email Address</div>
                    <div class="col text-end fw-bold">{{ customer.emailAddress }}</div>
                </div>
            </div>
            <div class="small my-3">
                <div class="row">
                    <div class="col">Appointment Id</div>
                    <div class="col text-end fw-bold">{{ appointment.id }}</div>
                </div>
                <div class="row">
                    <div class="col">Engineer</div>
                    <div class="col text-end fw-bold">{{ appointment.staffFullName }}</div>
                </div>
                <div class="row">
                    <div class="col">Appointment Start</div>
                    <div class="col text-end fw-bold">
                        {{ appointment.appointmentStart | date: 'dd/MM/yyyy HH:mm' }}
                    </div>
                </div>
                <div class="row">
                    <div class="col">Appointment End</div>
                    <div class="col text-end fw-bold">{{ appointment.appointmentEnd | date: 'dd/MM/yyyy HH:mm' }}</div>
                </div>
                <div class="row">
                    <div class="col">Time finished</div>
                    <div class="col text-end fw-bold">{{ appointment.timeFinishedJob | date: 'dd/MM/yyyy HH:mm' }}</div>
                </div>
                <div class="row">
                    <div class="col">Finished By</div>
                    <div class="col text-end fw-bold">{{ appointment.finishedByFullName || 'N/A' }}</div>
                </div>
            </div>
        }
    }

    <google-map #postMap width="100%" height="250px" [center]="center">
        @for (marker of markerPositions; track marker) {
            <map-marker
                [position]="marker.position"
                [label]="marker.label"
                [title]="marker.title"
                [options]="marker.options"></map-marker>
        }
    </google-map>

    <div class="d-grid gap-1 mt-2">
        <button sfButton type="button" size="md" color="warning" (click)="voidPost()">Void</button>
        <button sfButton type="button" size="md" color="warning">Remove</button>
        <button sfButton type="button" size="md" color="danger" (click)="deletePost()">Delete</button>
    </div>
    <hr />
    <button sfButton type="button" color="secondary" (click)="close()">Close</button>
</div>
